import React, { FC, useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TabsPanel } from 'ui';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchCoveredBoundsCountries } from 'services';
import { CoveredBondsList } from 'modules/creditRating/CoveredBonds/CoveredBondsList';
import { CountryListItem } from 'modules/creditRating/CoveredBonds/types';
import { prepareCountriesList } from '../../modules/creditRating/CoveredBonds/functions';

export const CoveredBonds: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { countryId } = useParams<{ countryId: string }>();
  const [activeTab, setActiveTab] = useState<string>();
  const [countriesList, setCountriesList] = useState<Array<CountryListItem>>([]);
  const [allTotal, setAllTotal] = useState<number>(0);

  const fetchCountriesList = async () => {
    const countries = await fetchCoveredBoundsCountries();
    setCountriesList(prepareCountriesList(countries, 'countryName', 'ASC'));
    const total = countries.reduce((sum: number, item: CountryListItem) => sum + item.number, 0);
    setAllTotal(total);
    setActiveTab(countryId?.toUpperCase());
  };

  const onTabChange = useCallback(
    (_: never, value: string) => {
      if (activeTab !== value || activeTab !== countryId) {
        setActiveTab(value);
        navigate(
          {
            pathname: `/covered-bonds/${value}`,
          },
          { replace: true },
        );
      }
    },
    [activeTab, countryId],
  );

  useEffect(() => {
    fetchCountriesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return activeTab ? (
    <>
      {/* @ts-ignore */}
      <TabsPanel
        key="CoveredBondsTabs"
        active={activeTab}
        hasShadow="true"
        onChange={onTabChange}
        variant="scrollable"
      >
        <div label={t('COVERED_BONDS.ALL')} value="ALL" key="ALL" counter={allTotal}>
          <CoveredBondsList
            countryCode="ALL"
            countryCodes={countriesList.map((country: CountryListItem) => country.countryCode)}
          />
        </div>
        {countriesList &&
          countriesList?.map((item: CountryListItem) => (
            <div
              label={t(item.countryName)}
              value={item.countryCode.toUpperCase()}
              key={item.countryCode}
              counter={item.number}
            >
              <CoveredBondsList
                countryCode={item.countryCode}
                countryCodes={countriesList.map((country: CountryListItem) => country.countryCode)}
              />
            </div>
          ))}
      </TabsPanel>
    </>
  ) : null;
};
